import { useEffect } from "react";
import { useNavigate } from 'react-router-dom';

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    //reset session
    localStorage.clear();
    navigate('/authentification', { replace: true });
  }, []);
}

export default Logout
